import type { FC } from "react";
import type { EmblemSetType } from "@/lib/domain/EmblemSet";
import { useEmblemStats } from "@/features/emblems/api/useEmblemStats";
import { getColorForEmblemRarity } from "@/features/emblems/getColorForEmblemRarity";
import { PercentageWheel } from "@/ds/custom/PercentageWheel";

export interface EmblemStatsProps {
	set: EmblemSetType;
}

export const EmblemStats: FC<EmblemStatsProps> = props => {
	const {
		set
	} = props;

	const emblemStats = useEmblemStats(set);

	if (!emblemStats.data) {
		return null;
	}

	return (
		<div className="flex items-center gap-6 justify-between pb-2 flex-wrap @md:pb-0 @md:justify-start @md:flex-nowrap @md:pr-2">
			{
				emblemStats.data.map(x => (
					<div key={x.rarity} className="flex items-center gap-1.5" style={{ color: getColorForEmblemRarity(x.rarity) }}>
						<PercentageWheel current={x.uniqueOwnedCount} max={x.uniqueTotalCount} className="w-6 h-6 shrink-0" />
						<span className="text-xs font-semibold text-foreground">{x.uniqueOwnedCount}/{x.uniqueTotalCount}</span>
					</div>
				))
			}
		</div>
	);
};
